import React, { useEffect, useState } from "react";
import { GetClients } from "../apiconstants/constants";
import axios from "axios";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };
   useEffect(() => {
  const fetchClients = async () => {
    const cached = localStorage.getItem("clientsCache");
    if (cached) {
      // Optional: you can preload cached clients if needed here
      const parsedClients = JSON.parse(cached);
      // setClients(parsedClients);  // if you want to show immediately
    } else {
      try {
        const response = await axios.get(GetClients.APIURL);
        const activeClients = response.data.filter(x => x.isActive);
        localStorage.setItem("clientsCache", JSON.stringify(activeClients));
        // setClients(activeClients);  // if you're using it in this component
      } catch (error) {
        console.error("Error fetching clients", error);
      }
    }
  };

  fetchClients();
}, []);

  return (
    <div>
      {/* Top Bar */}
      <div className="top-bar-area inc-pad bg-theme text-light">
        <div className="container">
          <div className="row d-flex justify-content-between">
          <div className="col-lg-6 info hide-on-mobile">
  <ul>
    <li style={{ fontSize: '16px' }}>
      <i className="fas fa-envelope-open"></i> hire@knackhook.com
    </li>
  </ul>
</div>

            <div className="col-lg-6 item-flex">
              <div className="social">
                <ul className="d-flex">
                  <li>
                    <a href="https://www.facebook.com/knackhook/" target="_blank" aria-label="Facebook" rel="noreferrer">
                      <i className="fab fa-facebook-f top-icon"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/Knack_Hook" target="_blank" aria-label="Twitter" rel="noreferrer">
                      <i className="fab fa-twitter top-icon"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/knackhook/mycompany/" target="_blank" aria-label="LinkedIn" rel="noreferrer">
                      <i className="fab fa-linkedin-in top-icon"></i>
                    </a>
                  </li>
                  
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container d-flex justify-content-between">
        <a className="navbar-brand" href="#">
          <img
            src="https://knackhire.azurewebsites.net/static/media/knackhire-new.fe8d9b9e9acf584d2427.png"
            className="img-fluid"
            style={{ height: "50px" }}
            alt="Knackhire Logo"
          />
        </a>

        {/* Toggle button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={handleToggle}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu content */}
        <div className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`} id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {["Home", "About", "Keybenefits", "PricingPlans", "Help"].map((section) => (
              <li className="nav-item" key={section}>
                <a className="nav-link" href={`/#${section}`} onClick={closeMenu}>
                  {section.toUpperCase()}
                </a>
              </li>
            ))}
            <li className="nav-item">
              <a
                className="btn btn-primary text-white nav-link"
                style={{ fontSize: "12px" }}
                href="/#Tour"
                onClick={closeMenu}
              >
                PRODUCT TOUR
              </a>
            </li>
          </ul>

          <ul className="d-flex">
            <li className="call-icons">
              <i className="fa fa-phone"></i>
            </li>
            <li className="contact">
              <p>Call us today!</p>
              <p><strong>+1 (425) 548-6321</strong></p>
            </li>
          </ul>
        </div>
      </div>
    </nav>
      <style jsx>{`
       .top-bar-area.bg-theme {
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.top-bar-area.inc-pad {
    padding: 15px 0;
}
.bg-theme {
    background-color: #00a7ac;
}
.top-bar-area.bg-dark .info li i, .top-bar-area.bg-theme .info li i {
    color: #ffffff;
}
.top-bar-area .info li i {
    margin-right: 5px;
    color: #00a7ac;
}
.top-bar-area .info li i {
    margin-right: 25px;
    color: #00a7ac;
}
.social {
    float: right;
   
}
.top-icon{
    margin-right: 20px;
}
a.navbar-brand {
    margin-right: 142px;
}
li.nav-item {
    margin-right: 20px;
    font-size: 15px;
    font-weight: 600;
}
li.call-icons {
    margin-right: 20px;
    border-right: 1px rgb(215, 215, 215) solid;
    height: 70px;
    padding: 20px;
    color: #00a7ac;
    font-size: 30px;
}



li.nav-item {
  margin-right: 10px;
  font-size: 13px;
  font-weight: 500;
}

.top-bar-area.bg-theme {
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.top-bar-area.inc-pad {
  padding: 15px 0;
}

.bg-theme {
  background-color: #00a7ac;
}

.top-bar-area.bg-dark .info li i,
.top-bar-area.bg-theme .info li i {
  color: #ffffff;
}

.top-bar-area .info li i {
  margin-right: 5px;
  color: #00a7ac;
}

.social {
  float: right;
}

.top-icon {
  margin-right: 20px;
}

a.navbar-brand {
  margin-right: 142px;
}

li.call-icons {
  margin-right: 20px;
  border-right: 1px rgb(215, 215, 215) solid;
  height: 70px;
  padding: 20px;
  color: #00a7ac;
  font-size: 30px;
}
  @media (max-width: 767px) {
  .hide-on-mobile {
    display: none !important;
  }
}

      `}</style>
    </div>
  );
};

export default Header;
